module.exports = __webpack_public_path__ + "static/media/template2.2646b758.png";